export default "__VITE_ASSET__CfEF7$$___"